import { __read } from "tslib";
export function getCleanObject(obj) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        if (val !== undefined) {
            acc[key] = val;
        }
        return acc;
    }, {});
}
//# sourceMappingURL=cleanupObject.js.map